<div
  (mouseenter)="item.selected = true"
  (mouseleave)="item.selected = false"
  class="d-flex flex-row"
>
  <div
    class="list-item menu-item col"
    (click)="item.selected = false"
    style="padding: 4px"
  >
    <div class="row menu-item" style="width: 234px">
      <div class="col-10">
        <button
          data-toggle="collapse"
          style="background-color: transparent; padding-top: 0"
          type="button"
          (click)="select(item)"
          class="btn-panel panel-heading-drop {{
            item.selected ? '' : 'collapsed'
          }}"
        >
          {{ item.description }}
        </button>
      </div>
      <div class="col-2 list-item-icon">
        <div *ngIf="item.children.length; else quantityBlock">
          <a class="panel-heading collapsed"></a>
        </div>
        <ng-template #quantityBlock>
          <span class="badge badge-secondary">{{ item.quantity }}</span>
        </ng-template>
      </div>
    </div>
  </div>
  <div
    *ngIf="item.children.length > 0"
    id="box{{ item.id }}"
    class="list-group list-group-flush panel-collapse collapse col {{
      item.selected ? 'show' : ''
    }}"
    style="position: absolute; margin-left: 240px"
  >
    <div class="dropdown-box" style="padding: 0">
      <app-treeview-link-horizontal
        #submenu
        [selected]="i.selected"
        (onSelect)="onChildrenSelected($event)"
        *ngFor="let i of item.children"
        [item]="i"
        [parent]="parent + ' > ' + item.description"
        (breadCrumb)="saveBc($event)"
      ></app-treeview-link-horizontal>
    </div>
  </div>
</div>
